import { useTranslation } from 'react-i18next';
import { useCompany } from '../../contexts/CompanyContext';

export function CompanySwitcher() {
  const { t } = useTranslation();
  const { activeCompany, companies, setActiveCompany, isLoading } = useCompany();

  if (isLoading) {
    return (
      <div className="flex h-9 items-center rounded-xl border border-white/25 px-3 text-xs text-white/80">
        {t('common.loading')}
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <div className="flex h-9 items-center rounded-xl border border-white/25 px-3 text-xs text-white/80">
        {t('company.noCompanySelected')}
      </div>
    );
  }

  return (
    <div className="relative flex items-center gap-2">
      <select
        value={activeCompany?.id ?? ''}
        onChange={(e) => setActiveCompany(e.target.value)}
        className="h-9 rounded-xl border border-white/25 bg-white/10 px-3 pr-7 text-xs font-medium text-white transition-colors hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40 [&>option]:text-gray-900"
        aria-label={t('company.selectCompany')}
      >
        {!activeCompany && (
          <option value="" disabled>
            {t('company.selectCompany')}
          </option>
        )}
        {companies.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
      {activeCompany && (
        <span className="hidden rounded-lg bg-white/15 px-2 py-0.5 font-mono text-xs text-white/90 sm:inline">
          {activeCompany.code}
        </span>
      )}
    </div>
  );
}
